import styled, { keyframes } from 'styled-components';

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const DeleteConfirmation = styled.div`
  position: absolute;
  width: calc(100% + 60px);
  height: 100%;
  margin-left: -30px;
  border-radius: 5px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 10;
  background-color: ${({ theme }) => theme.white.a9};
  animation: ${fadeIn} 250ms ease-out;
`;

export const ModalTitle = styled.span.attrs({ className: 'hl3' })`
  color: ${({ theme }) => theme.baseBlue.a10};
`;

export const ModalSubtitle = styled.div.attrs({ className: 'body_text' })`
  margin-top: 5px;
  color: ${({ theme }) => theme.baseBlue.a6};
`;

export const ButtonWrapper = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
  > button {
    margin-right: 10px;
  }
`;
